self.addEventListener('fetch', function(event) {
});

console.log('Coucou !')

/**
 * //!\ Besoin d'une réponse 200 en hors-ligne après mi-2021
 * 
 * https://developer.chrome.com/blog/improved-pwa-offline-detection/
 * 
 * Starting in mid-2021, Chrome will require that the fetch event handler
 * return a valid response when the device is offline.
 */